<style>
	.bg555 {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 0.2s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw; }
.tabbar8{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.5vw;background-size:105% 105%;  }
.tabbar8 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar8 span.pos{ padding:0 1vw;}
.tabbar8 span.floder{ color:#666;}
 
.tabbar8 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;} 
  


.sj_lists{width:84vw;margin-left:7vw;margin-top:1vw;height:10.5vw;border:#e5e5e5 solid 1px;}
.sj_left{width:40vw;height:100%; position:relative;float:left;}
.sj_left input{ width: 1.4vw;height:1.4vw;border-radius:.5vw;display:block;float:left;-webkit-border-radius:.5vw;position:absolute;left:1vw;top:1vw;}
.sj_left img{display:block;position:absolute;top:1vw;left:3vw;width:2vw;}
.sj_left_title{width:50vw;height:2vw;position:absolute;left:5vw;top:1vw;}
.sj_left_title span{display:block;float:left;line-height:2vw;}
.sj_left_title span.t1{font-size:1.2vw;color:#0F7A3E;cursor: pointer;}
.sj_left_title span.t2{font-size:1vw;padding-left:.5vw;color:#999;}
.sj_left span.fl{position:absolute;display:block;top:3.5vw;left:5vw;font-size:1.2vw;color:#999;border:#ddd solid 1px;height:2vw;line-height:2vw;padding:0 .5vw;
    border-radius:.5vw;}
.sj_left span.fl55{position:absolute;display:block;top:5.5vw;left:5vw;font-size:1vw;color:#999;height:2vw;line-height:2vw;padding:0 .5vw;}
	
.sj_middle{width:10vw;height:100%;border-right:#ddd solid 1px;float:right;box-sizing:border-box;border-left:#ddd solid 1px;}
.sj_middle span{display:block;height:2.65vw;line-height:2.65vw;text-align:left;border-bottom:#ddd solid 1px;width:8vw;padding:0 1vw;font-size:1.2vw;
 color:#333;}
 
.sj_right{width:10vw;height:100%; float:right;box-sizing:border-box;margin: 0;padding: 0;overflow: hidden;}
.sj_right span{display:block;height:2.65vw;line-height:2.65vw;text-align:left;width:5vw;padding:0 1vw;font-size:1.2vw;
 color:#333;float: left;}
.sj_right span.mn2{color:#0F7A3E;}
.sj_right span.mn3{color:#f00;width: 3.5vw;}

.sj_r_box{width: 10vw;height: 2.65vw;margin: 0;padding: 0;overflow: hidden;border-bottom:#ddd solid 1px;}
 
.sj_right span.dc{ text-align: center;float: left;width: 4.5vw;float: left;padding: 0;cursor: pointer;color: #3465ff;
 border-left: #eee solid 1px;text-align: center; box-sizing: border-box;}

.sj_fresh{width:10vw;height:100%;border-left:#ddd solid 1px;box-sizing:border-box;float:right;}
.sj_fresh img{display:block;margin:0 auto;width:2.5vw;margin-top:2vw;}
.sj_fresh span{display:block;width:100%;text-align:center;line-height:3vw;color:#3465ff;font-size:1.2vw;}

.pages{margin:0 auto;padding:0;overflow:hidden;width:84vw;height:4vw; margin-top:2vw;} 
.pre{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;}
.pre img{width:2vw;margin-top:.25vw;margin-left:.2vw;}
 
.next{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;margin-left:1vw;}
.next img{width:2vw;margin-top:.25vw;margin-left:.25vw;}

.submits6{width:22vw;height:4vw;border-radius:.5vw;float:right; }
.submits6 button{outline:none;border:0;font-size:1.2vw;display:block;height:4vw;line-height:4vw;width:10vw;color:#fff;border-radius:.5vw;float:right;}
.submits6 button.ck{outline:none;border:#ddd solid 1px;font-size:1.2vw;display:block;height:4vw;line-height:4vw; color:#333;border-radius:.5vw;background:none;
float:left;}
.submits6 button.zong{background:#3268ff;}
.send_resultss{margin-top:2vw;height: 34.5vw;}


.rs_head{width:84vw;margin-left:7vw;margin-top:6vw;border:#3465ff solid 2px;height:4vw;border-top-left-radius:.5vw;border-top-right-radius:.5vw;
box-sizing:border-box; position:relative;z-index:9;}
.rs_head span{display:block;float:left;height:4vw;line-height:4vw;font-size:1.1vw;text-align:center;}
 

.rs_head span.sais{display:block;float:left;height:3.8vw;background:#3465ff;width:15vw;color:#fff;position:absolute;left:0;top:0;z-index:9;
box-sizing:border-box;font-weight: bold;}
.rs_head ul.xxx{position:absolute;left:15vw;top:0;}
.rs_head ul.xxx li{float:left;width:13.5vw;position:relative;margin:0;padding:0;overflow:hidden;height:4vw;cursor:pointer;}
.rs_head ul.xxx li span.val{width:12vw;position:absolute;font-weight: bold;}
.rs_head ul.xxx li img{position:absolute;top:1.2vw;width:1.5vw;right:1vw;}
.rs_head ul.xxx li span.border{width:1px;height:2vw;border-right:#ddd soliid 1px;position:absolute;right:0;top:1vw;}



.xialas{position:absolute;top:3.6vw;background:#fff;width:13.5vw;left:15vw;border:#ddd solid 1px;border-top:0;z-index:999999;box-sizing:border-box;
      max-height:30vw;  overflow-x: hidden;border-radius:.5vw;border-top-left-radius:0;border-top-right-radius:0;}
.xialas ul li{width:100%;height:3vw;line-height:3vw;text-align:center;border-bottom:#ddd solid 1px;box-sizing:border-box;font-size:1.1vw;
  cursor:pointer;}
.xialas ul li:last-child{border-bottom:0;}
.xialas ul li:hover{background:#d6e7f9;}
 
.xiala22{left:28.5vw;}
 
.xiala33{left:42vw;}
 
.xiala44{left:55.5vw;}
 
.xiala55{left:69vw;}

 
.sj-left-outer{width: 74vw;height: 10.5vw;float: left;}
.sj-left-top{width: 74vw;height:8vw;  }
.sj-left-bottom{width: 100%;height: 2.5vw;background: #f6f6f6;line-height: 2.5vw;font-size: 1.2vw;text-indent: 5vw}
</style>
 
<template>
	<div class="bg555">
	      

		
	     <u_center  ></u_center>
	     <div class="top_area">
		    <img @click="home()" src="../../assets/images/home_icon.png">
			<div class="tabbar8">
			   <span class="pos">您的当前位置:</span>
			   <span class="floder">发送记录</span>
			    
			</div>
		 </div>
		   <div class="rs_head">
		    <span class="sais">筛选历史发送数据</span>
			<ul class="xxx">
			   <li @click="xiala(1)"><span class="val">{{year}}</span><img src="../../assets/images/down.png"><span class="border"></span></li>
			   <li @click="xiala(2)"><span class="val">{{leibie}}</span><img src="../../assets/images/down.png"><span class="border"></span></li>
			   <li @click="xiala(3)"><span class="val">{{pici}}</span><img src="../../assets/images/down.png"><span class="border"></span></li>
			   <li @click="xiala(4)"><span class="val">{{dalei}}</span><img src="../../assets/images/down.png"><span class="border"></span></li>
			   <li @click="xiala(5)"><span class="val">{{area}}</span><img src="../../assets/images/down.png"></li>


               <!--
			   <li @click="xiala(1)"><span class="val">{{leibie}}</span><img src="../../assets/images/down.png"><span class="border"></span></li>
			   <li @click="xiala(2)"><span class="val">{{riqi}}</span><img src="../../assets/images/down.png"><span class="border"></span></li>
			   <li @click="xiala(3)"><span class="val">{{shuju}}</span><img src="../../assets/images/down.png"></li>
			  -->
			</ul>

                <transition name="draw">
				   <div class="xialas" v-show="xiala1">
					  <ul>
					      <li  @click="select_year('全部',0)">全部</li>
						 <li v-for="item in year_list" @click="select_year(item.year,item.id)">{{item.year}}</li>
					  </ul>
				   </div>
			   </transition>
               <transition name="draw">
				   <div class="xialas xiala22" v-show="xiala2">
					  <ul>
					      <li  @click="select_zhao('全部',0)">全部</li>
						 <li v-for="item in zhao_list" @click="select_zhao(item.name,item.id)">{{item.name}}</li>
					  </ul>
				   </div>
			   </transition>
               <transition name="draw">
				   <div class="xialas xiala33" v-show="xiala3">
					  <ul>
					     <li  @click="select_pi('全部',0)">全部</li>
						 <li v-for="item in pici_list" @click="select_pi(item.name,item.id)">{{item.name}}</li>
					  </ul>
				   </div>
			   </transition>
			    <transition name="draw">
				   <div class="xialas xiala44" v-show="xiala4">
					  <ul>
					     <li  @click="select_lei('全部',0)">全部</li>
						 <li v-for="item in lei_list" @click="select_lei(item.name,item.id)">{{item.name}}</li>
					  </ul>
				   </div>
			   </transition>
			   <transition name="draw">
				   <div class="xialas xiala55" v-show="xiala5">
					  <ul>
						 <li v-for="item in area_list" @click="select_area(item.region_name,item.id)">{{item.region_name}}</li>
					  </ul>
				   </div>
			   </transition>
			   
			   
		 </div>
		 <div class="send_resultss">  
		 <div class="sj_lists " v-for="item in list">
		 	<div class="sj-left-outer">
		 	<div class="sj-left-top">
	                <div class="sj_left">
				     
					<img src="../../assets/images/excel.png">
					<div class="sj_left_title">
						<span class="t1" @click="down(item.file_name)" title="点击下载">{{item.name}}</span>
						 
					</div>
					<span class="fl">{{item.year}}年-{{item.zs_category}}-{{item.grade}}-{{item.category}}-{{item.area}}-{{item.type}}</span>
					<span class="fl55"></span>
				 </div>
				 
	              <div class="sj_right">
				      <div class="sj_r_box"><span class="mn1">{{item.TotalCount}}条</span></div>
					  <div class="sj_r_box"><span class="mn2">{{item.success}}人</span></div>
					  <div class="sj_r_box"><span class="mn3" style="border-bottom:0;">{{item.failed}}人</span>
					  	                     <span class="dc" @click="view_results3(item.id)">查看</span>
					  </div>
				 </div>
				 <div class="sj_middle">
				      <span class="m1">计费短信数</span>
					  <span class="m2">通知用户</span>
					  <span class="m3" style="border-bottom:0;">发送失败</span>
				 </div>
			</div>
               <div class="sj-left-bottom">发送时间:{{item.time|formatDate}}
               </div>
            </div>

			 <div class="sj_fresh" @click="refresh()">
			    <img src="../../assets/images/fresh.svg">
				<span >刷新数据</span>
			 </div>
         </div>
         </div>	 
         <div class="pages">
		   <div v-if="total_page>1">
				<div class="pre" @click="pre_page()"   v-if="page>1">
				   <img src="../../assets/images/pre2.png">
				</div>
				<div class="pre"   v-else>
				   <img src="../../assets/images/pre1.png">
				</div>
				
				<div class="next" @click="next_page()" v-if="page<total_page">
				   <img src="../../assets/images/next1.png">
				</div>
				<div class="next"  v-else>
				   <img src="../../assets/images/next2.png">
				</div>
			</div>
			 
		 </div>
	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
import Progress from "easy-circular-progress";
	export default {
	    components: {
		  u_center,
		  Progress
	    },
		data() {
			return {
				 list:[],			   
				 all_check:false,
				 
				 year:"招生学年",
				 year_list:[],
				 xiala1:false,
				 xiala2:false,
				 xiala3:false,
				 xiala4:false,
				 xiala5:false,
				 leibie:"招生类型",
				 zhao_list:[{id:1,zhao:'统招'},{id:2,zhao:'单招'}],
				 pici:'招生批次',
				 pici_list:[{id:1,pi:'本科批'},{id:2,pi:'专科批'}],
				 dalei:"专业类别",
				 lei_list:[{id:1,lei:'普通类'},{id:2,lei:'财经类'},{id:3,lei:'艺术类'},{id:4,lei:'计算机类'}],
				 area:"招生地区",
				 area_list:[{id:0,area:'全国'},{id:2,area:'北京'},{id:3,area:'天津'},{id:4,area:'上海'},{id:5,area:'河北'},{id:6,area:'河南'}],
                 year_id:'',
				 zs_category_id:'',
				 grade_id:'',
				 category_id:'',
				 area_id:'',
				 progress_show:true,
				 onkey_show:false,
				 safe_show:false,
				 mode:2,
				 task_id:"",
				 page:1,
				 total_page:1
				 
			}
		},filters: {
				formatDate: function(value) {
					var date = new Date();
					 date.setTime(value*1000);
					var month = date.getMonth() + 1;
					var hours = date.getHours();
					if (hours < 10)
						hours = "0" + hours;
					var minutes = date.getMinutes();
					if (minutes < 10)
						minutes = "0" + minutes;
					var time = date.getFullYear() + "-" + month + "-" + date.getDate() +
						" " + hours + ":" + minutes;
					return time;
				}
			},
		mounted() {
		    let self=this;
		    this.task_id = this.$utils.getUrlKey('task_id');
		      var token= localStorage.getItem("token");
			  if(!token){
					 self.$router.push("/");  
			  }else{
			      self.token=token;
				  self.get_task_list();
				  self.get_sms_type();
				  self.get_import_key();
			  }  
		},
		methods: {
			down(url){
             //  window.location.href=this.$api+'/'+url;
               window.open(this.$api+'/'+url,'_system')
			},
			view_results3(id){
              this.$router.push("/view_results3?id="+id);  
			},
		    home(){
			  this.$router.push("/");  
			},
			look_his(){
			  this.task_id="";
			  this.get_task_list();
			},
			refresh(){
			   this.get_task_list();
			   this.$loading('刷新中...');
			   let self=this;
			                 setTimeout(function(){
								        self.$loading.close();
										 self.$toast.center('刷新成功');
					         },1000);
	 
			},
			 pre_page(){
		     if(this.page>1){
			    this.page=this.page-1;
				this.get_task_list();
			 }
		   },next_page(){
		      if(this.page<this.total_page){
			    this.page=this.page+1;
				this.get_task_list();
			  }
		   },daochu(){
		        this.$toast.center('暂无失败数据');
		   },get_import_key(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_import_key', {
					   token:self.token
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
				      self.riqi_list=data.data.year_list;		 
                      self.area_list=data.data.area;
                      self.lei_list=data.data.category_list;
                      self.pici_list=data.data.grade;	
                      self.zhao_list=data.data.zs_list;	
                      self.year_list=data.data.year_list;		
                       				  
				  } 
		      }).catch(function (error) {
			         
		      });
		   },
		   get_task_list(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_send_histiry', {
					   token:self.token,
					   page:self.page,
					   year_id:self.year_id,
					   zs_category_id:self.zs_category_id,
					   grade_id:self.grade_id,
					   category_id:self.category_id,
					   area_id:self.area_id,
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 self.list=data.data.list;
                     self.total_page=data.data.total_page;					 
				  } 
		      }).catch(function (error) {
			         
		      });
		   },get_sms_type(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_sms_type', {
					   token:self.token
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 self.leibie_list=data.data;	
					  				 
				  } 
		      }).catch(function (error) {
			         
		      });
		  },
		    check(id,val){
			    var new_list=[];                   
				this.list.forEach(function(obj,index){
					new_list[index]=obj;
					if( obj.id==id){
						new_list[index].on=val;
					} 
				});
			    this.list=new_list;
				console.log(this.list)
			},all(val){
			    var new_list=[];                   
				this.list.forEach(function(obj,index){
					new_list[index]=obj;
					new_list[index].on=val; 
				});
			    this.list=new_list;
			},xiala(id){
			  if(id==1){
			     this.xiala1=!this.xiala1;this.xiala2=false;this.xiala3=false;this.xiala4=false;this.xiala5=false;
			  }else if(id==2){
			     this.xiala2=!this.xiala2;this.xiala1=false;this.xiala3=false;this.xiala4=false;this.xiala5=false;
			  }else if(id==3){
			     this.xiala3=!this.xiala3;this.xiala1=false;this.xiala2=false;this.xiala4=false;this.xiala5=false;
			  }else if(id==4){
			     this.xiala4=!this.xiala4;this.xiala1=false;this.xiala2=false;this.xiala3=false;this.xiala5=false;
			  }else if(id==5){
			     this.xiala5=!this.xiala5;this.xiala1=false;this.xiala2=false;this.xiala3=false;this.xiala4=false;
			  }
			},select_year(year,id){
			    if(id==0){
					this.year='招生学年';
				}else{
					this.year=year;
				}
			  this.xiala1=false;
			  this.year_id=id;
			  this.get_task_list();
			},select_zhao(zhao,id){
				if(id==0){
					this.leibie='招生类型';
				}else{
					this.leibie=zhao;
				}
			  
			  this.xiala2=false;
			  this.zs_category_id=id;
			  this.get_task_list();
			},select_pi(pi,id){
				if(id==0){
					this.pici='招生批次';
				}else{
					this.pici=pi;
				}
			  
			  this.xiala3=false;
			  this.grade_id=id;
			  this.get_task_list();
			},select_lei(lei,id){
				if(id==0){
					this.dalei='专业类别';
				}else{
					this.dalei=lei;
				}
			  
			  this.xiala4=false;
			  this.category_id=id;
			  this.get_task_list();
			},select_area(area,id){
				if(id==1){
					this.area='招生地区';
				}else{
					this.area=area;
				}
			  
			  this.xiala5=false;
			  this.area_id=id;
			  this.get_task_list();
			}
		     
		},watch:{
			 all_check(){
			   if(this.all_check==true){
			     this.all(1)
			   }else{
			     this.all(0)
			   }
			 }
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/sms/send_history.vue